import styled from 'src/styles/styled'

type ActionProps = React.ButtonHTMLAttributes<HTMLButtonElement>

const Action = styled.button<ActionProps>`
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: ${props => props.theme.colors.dodgerBlue};
  cursor: pointer;

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.skyBlue};
  }

  &:disabled {
    color: ${props => props.theme.colors.lightGrey};
    cursor: not-allowed;
    opacity: 0.7;
  }
`

export default Action
